import styled from '@emotion/styled'
import * as v from '../../../../../variables/styled'

export const SummaryContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',

  '.MuiCard-root': {
    marginBottom: '10px',
  }, 

  '.MuiCardContent-root': {
    paddingTop: '0px',
    marginBottom: '10px',
  }, 

  '.cardHeaderActions': {
    button: {
      background: 'transparent',
    }
  }
})

export const RequestInformationContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',

  '.sectionRow': {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
})

export const GeneralInfoContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',

  '.rowFields': {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
})

export const SpecialPrContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',

  '.rowFields': {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
})

export const ItemsContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',

  '.alignLeft': {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-start',
  },

  '.alignRight': {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end'
  },

  '.alignCenter': {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
  },
})

export const TotalAmountContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  marginTop: '5px',
  padding: '5px',
  fontSize: '12rem',

  '.labelText': {
    display: 'flex',
    fontWeight: 'bold',
    marginRight: '15px',
    alignItems: 'center',
  },

  '.centerContent': {
    fontSize: '12px',
    fontWeight: 'bold',
  }
})

export const BudgetContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  marginTop: '10px',

  '.MuiCard-root': {
    marginBottom: '10px',
  }, 

  '.MuiCardContent-root': {
    paddingTop: '0px',
    marginBottom: '10px',
  }, 

  '.cardHeaderActions': {
    button: {
      background: 'transparent',
    }
  },

  '.budgetTable': {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '10px',

    'span.tableTitle': {
      fontSize: '1.2rem',
      fontWeight: 'bold',
    }
  },

  '.alignRight': {
    display: 'flex',
    justifyContent: 'flex-end',
  },

  '.alignCenter': {
    display: 'flex',
    justifyContent: 'center',
  },
})

export const DisplayFieldContent = styled.div({
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
  padding: '5px 0px',
  marginRight: '10px',

  '&:last-child': {
    marginRight: '0px',
  },

  '.labelText': {
    fontSize: '1rem',
    marginRight: '5px',
    color: '#777',
  },

  '.valueText': {
    display: 'flex',
    flex: 1,
    borderBottom: 'solid 1px #EEE',
    paddingLeft: '8px',
    fontSize: '1.15rem',
  },
})